import { TableManger, TABLES } from "../managers/TableManger";
import Table from "./table";
export class CampaignService {

  static getColumnsData(isRequiredOnly) {
    let allCampaignColumns = TableManger.getTableColumns(TABLES.CAMPAIGN)
    if (isRequiredOnly) {
      return (allCampaignColumns || []).filter(item => item.required === true)
    }
    return allCampaignColumns
  }

  static add(data, tableId) {
    return Table.addRecord({ cells: data }, tableId)
  };

  static update(data, tableId, recordId) {
    return Table.updateRecord(data, recordId, tableId)
  }

  static getData(recordId, tableId) {
    return Table.getRecordById(recordId, tableId)
  }
}
